/**
 * 導覽列「客戶」連結(REQ-20260421008 §5)。
 * 點擊時優先跳到上一次檢視的客戶 URL(存在 sessionStorage),否則跳預設 console。
 *
 * 搭配 CustomerConsolePage 在檢視客戶時寫入 sessionStorage['console:last']。
 * 登出時由 auth store 呼叫 clearLastConsoleUrl() 清除。
 */
import { Link } from 'react-router-dom';

const KEY = 'console:last';
const DEFAULT_URL = '/customers/console';

export function getLastConsoleUrl(): string | null {
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setLastConsoleUrl(url: string): void {
  try {
    window.sessionStorage.setItem(KEY, url);
  } catch {
    // 隱私模式 / quota 超限 → 靜默失敗,不影響主功能
  }
}

export function clearLastConsoleUrl(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}

export function CustomersNavLink({
  className,
  children,
  active,
}: {
  className?: string;
  children: React.ReactNode;
  active?: boolean;
}): JSX.Element {
  const to = getLastConsoleUrl() ?? DEFAULT_URL;
  const borderClass = active ? 'border-b-2 border-blue-600' : 'border-b-2 border-transparent';
  return (
    <Link to={to} className={`${className ?? ''} ${borderClass}`} data-testid="nav-customers">
      {children}
    </Link>
  );
}
